exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-source-forms-blocks-subheader-styles__hoverState:hover {\n  background-color: var(--cps-color-silver) !important;\n}\n\n.src-source-forms-blocks-subheader-styles__subheader {\n  font-size: 1.6rem;\n  padding-top: 24px;\n  width: calc(100% - 2.4rem);\n  border-bottom: 0.1rem solid var(--cps-color-silver);\n  margin-left: 2.4rem;\n  padding-right: 2.4rem;\n}\n\n.src-source-forms-blocks-subheader-styles__blankSubheader {\n  padding: 0.8rem;\n}\n", ""]);

// exports
exports.locals = {
	"hoverState": "src-source-forms-blocks-subheader-styles__hoverState",
	"subheader": "src-source-forms-blocks-subheader-styles__subheader",
	"blankSubheader": "src-source-forms-blocks-subheader-styles__blankSubheader"
};